import { makeStyles } from 'tss-react/mui';

const name = 'ProjectList';

export const useProjectListStyles = makeStyles({ name })(theme => ({
  notAddedText: {
    borderBottom: `1px dashed ${theme.palette.link.main}`,
  },
}));
